import { useParams } from 'react-router-dom';
import { StreamInsightsTab } from '@/components/StreamInsightsTab';

export function StreamPage() {
  const { profileId: profileIdParam } = useParams<{ profileId: string }>();
  const profileId = profileIdParam ? decodeURIComponent(profileIdParam) : '';

  return (
    <div className="mx-auto w-full max-w-[1600px] px-6 pb-8 pt-1">
      <header className="mb-4">
        <h1 className="text-2xl font-semibold text-foreground">Dayparting</h1>
      </header>

      <StreamInsightsTab profileId={profileId} />
    </div>
  );
}

export function StreamV2Page() {
  const { profileId: profileIdParam } = useParams<{ profileId: string }>();
  const profileId = profileIdParam ? decodeURIComponent(profileIdParam) : '';

  return (
    <div className="mx-auto w-full max-w-[1600px] px-6 pb-8 pt-1">
      <header className="mb-4">
        <h1 className="text-2xl font-semibold text-foreground">Dayparting v2</h1>
      </header>

      <StreamInsightsTab profileId={profileId} source="v2" />
    </div>
  );
}
